import { render, staticRenderFns } from "./ApprovalBilling.vue?vue&type=template&id=21ef8b2d&scoped=true"
import script from "./ApprovalBilling.vue?vue&type=script&lang=js"
export * from "./ApprovalBilling.vue?vue&type=script&lang=js"
import style0 from "./ApprovalBilling.vue?vue&type=style&index=0&id=21ef8b2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ef8b2d",
  null
  
)

export default component.exports